import YandexMapsApi from '@/scripts/old/modules/YandexMapsApi';

function Map() {
  const self = this;

  self.init = function init(element) {
    const $wrap = $(element);

    if ($wrap.data('app-module-initialized')) return; // Prevent double init

    const center = $wrap.data('center') || [59.942422, 30.297085];
    const zoom = $wrap.data('zoom') || 16;
    const markers = $wrap.data('markers');
    const markerImage = $wrap.data('marker-image');
    const controls = $wrap.data('controls');

    YandexMapsApi.get().then((ymaps) => {
      const map = new ymaps.Map(element, {
        center,
        zoom,
        controls,
      });

      YandexMapsApi.fixScroll(map);

      if (markers && markers.length > 0) {
        markers.forEach((marker) => {
          const placemark = new ymaps.Placemark(
            marker.latlng,
            {
              balloonContent: marker.text,
            },
            {
              iconLayout: 'default#image',
              iconImageHref: markerImage,
              iconImageSize: [44, 40], // 88x80
              iconImageOffset: [-17, -40],
            },
          );

          map.geoObjects.add(placemark);
        });
      }
    });

    $wrap.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-map').each(function init() {
      self.init(this);
    });
  };
}

export default new Map();
